import { defineSlotRecipe } from '@chakra-ui/react';
import { emptyStateAnatomy } from '@chakra-ui/react/anatomy';

export const emptyStateRecipe = defineSlotRecipe({
  className: 'ac-emptystate',
  slots: emptyStateAnatomy.keys(),
  base: {
    root: {
      width: '100%',
    },
    content: {
      margin: 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',

      maxWidth: '450px',
    },
    indicator: {
      // '& svg': {
      //   stroke: 'grey.dark.1',
      // },
    },
    title: {
      margin: '16px 0px',
      fontSize: '18px',
      fontWeight: 'normal',
      color: 'grey.dark.2',
    },
    description: {
      margin: '0px',
      fontSize: '14px',
      fontWeight: 'normal',
      color: 'grey.dark.2',
    },
  },
  variants: {
    align: {
      left: {
        content: {
          alignItems: 'flex-start',
        },
      },
      center: {
        content: {
          alignItems: 'center',
        },
      },
    },
  },
  defaultVariants: {
    align: 'center',
  },
});
